import { render, staticRenderFns } from "./PayFail.vue?vue&type=template&id=06f6bcec&lang=pug&"
import script from "./PayFail.vue?vue&type=script&lang=js&"
export * from "./PayFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports